
import { useEffect } from 'react'
import Select from 'react-select'
import { ContractorNameDDLAPI, DepartmentDDLAPI, SectorDDLAPI, WardNameDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { AstricSign } from '../../Helper/AstricSign'

export const ContractorNameDDL = (props) => {
    const { ContractorName, setContractorName, CropNameDashboardData, rowData, Flag, IsPost } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_UserID: UserID,
            token: token
        }
        dispatch(ContractorNameDDLAPI({ data }))
    }, [IsPost])

    const { ContractorNameDDLData } = useSelector(state => state.ContractorNameDDLData)

    useEffect(() => {
        handleContractorNameDDL()
    }, [ContractorNameDDLData])

    const handleContractorNameDDL = () => {
        // console.log(DeptDDLDataa)
        if (ContractorNameDDLData && ContractorNameDDLData.table && ContractorNameDDLData.table.length > 0) {
            let list = ContractorNameDDLData.table.map((item, index) => ({
                value: item.m_ContractorID,
                label: item.contractorName,
            }))

            setContractorName({
                DDL: list,
                ID: Flag === 'Update' ? rowData.contractorNameID : 0,
                Label: Flag === 'Update' ? rowData.contractorName : "Select...",
            })
        }
        else {
            setContractorName({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofDepartment"><b>Contractor Name {Flag && <AstricSign />} </b></label>
            <Select
                isClearable
                // isRtl={isRtl}
                // className="ddl_width"
                isSearchable
                maxMenuHeight={150}
                value={{ value: ContractorName.ID, label: ContractorName.Label }}
                onChange={(e) => {
                    e ?
                        setContractorName({ ...ContractorName, ID: e.value, Label: e.label })
                        :
                        setContractorName({ ...ContractorName, ID: 0, Label: "Select..." })

                }}
                options={ContractorName.DDL}
            />
        </div>
    )
}